import { defineComponent, ref, watch, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useMainStore } from '@/store/main/main'
import { apiDocSections } from '@/modules/api/docs/registry'

export default defineComponent({
  name: 'ApiDocsMenuComponent',
  setup() {
    const route = useRoute()
    const mainStore = useMainStore()

    const isMobile = computed(() => mainStore.isMobile)

    // Меню строится по общему списку страниц: раздел из одной страницы — ссылка без вложений.
    const items = ref(apiDocSections.map(section => section.pages.length === 1
      ? { title: section.title, isOpen: true, children: [] as { title: string, path: string }[], to: `/api/${section.pages[0].path}` }
      : {
          title: section.title,
          isOpen: false,
          children: section.pages.map(entry => ({ title: entry.title, path: `/api/${entry.path}` })),
        }))

    const findMenuItemIndex = (title: string) => items.value.findIndex(item => item.title === title)

    const hasActiveChildren = (title: string) => {
      const itemIndex = findMenuItemIndex(title)
      if (itemIndex !== -1) {
        return items.value[itemIndex].children.some(child => child.path === route.path)
      }
    }

    const toggleIsOpen = (title: string) => {
      const itemIndex = findMenuItemIndex(title)
      if (itemIndex !== -1) {
        if (!items.value[itemIndex].children.length)
          return
        items.value[itemIndex].isOpen = !items.value[itemIndex].isOpen
      }
    }

    const setOpenStateIfChildActive = (path: string) => {
      const parent = items.value.find(i => i.children.some(c => c.path === path))
      if (parent && !parent.isOpen) {
        toggleIsOpen(parent.title)
      }
    }

    watch(
      () => route.path,
      newVal => {
        setOpenStateIfChildActive(newVal)
      },
    )

    onMounted(() => {
      setOpenStateIfChildActive(route.path)
    })
    return { isMobile, items, hasActiveChildren, toggleIsOpen }
  },
})
